import { FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { UtilsService } from '@common/services';
import { CustomErrorKey } from '@ui/components/form9/common/error-msg.service';

export type digitsLength = '' | 'exact' | 'min' | 'minmax';

export function inputDigits9RequiredValidator (type: digitsLength, minDigits?: number, maxDigits?: number, errorMsg: string = null): ValidatorFn
{
    return (formControl: FormControl): ValidationErrors | null =>
    {
        let validationErrors: ValidationErrors = null;

        if (UtilsService.isNullOrEmpty(formControl.value))
        {
            validationErrors = { required: true };
        }
        else
        {
            const regexp = new RegExp(`\\d{${minDigits},${maxDigits}}`);

            if (!formControl.value.match(regexp))
            {
                switch (type)
                {
                    case 'exact':
                        if (!UtilsService.isNullOrEmpty(errorMsg))
                        {
                            validationErrors = { [CustomErrorKey]: { [errorMsg]: { exact: minDigits } } };
                        }
                        else
                        {
                            validationErrors = { 'DIGITSEXACT': { exact: minDigits } };
                        }

                        // validationErrors = { [errorMsg ?? 'DIGITSEXACT']: { exact: minDigits } };
                        break;

                    case 'min':
                        if (!UtilsService.isNullOrEmpty(errorMsg))
                        {
                            validationErrors = { [CustomErrorKey]: { [errorMsg]: { min: minDigits } } };
                        }
                        else
                        {
                            validationErrors = { 'DIGITSMIN': { min: minDigits } };
                        }
                        // validationErrors = { [errorMsg ?? 'DIGITSMIN']: { min: minDigits } };
                        break;

                    case 'minmax':
                        validationErrors = { [errorMsg ?? 'DIGITSMINMAX']: { min: minDigits, max: maxDigits } };
                        break;

                    default:
                        validationErrors = { [errorMsg ?? 'DIGITS']: true };
                }
            }
        }

        return validationErrors;
    };
}
